
































import {
  defineComponent,
  computed,
  ref,
} from '@vue/composition-api';
import FormField from '@/components/form-field';
import type {
  ApplyChannelData,
  ApplyProductData,
} from '@/api/apply-product/types';
import { ChannelDisableEnum } from '@/api/apply-product/types';
import ChannelSelectView from './components/channel-select-view/index.vue';
import { displayLoadingText } from '../../product';

export default defineComponent({
  name: 'SelectChannelFormField',
  components: {
    FormField,
    ChannelSelectView,
  },
  props: {
    channel: {
      type: Object as () => ApplyChannelData,
      default: () => null,
      required: true,
    },
    product: {
      type: Object as () => ApplyProductData,
      default: () => null,
      required: true,
    },
    channelList: {
      type: Array as () => ApplyChannelData[],
      default: () => [],
    },
    switchChannelOpenRemindPopup: {
      type: Function,
      default: () => () => Promise.resolve(false),
    },
  },
  emits: ['change'],
  setup(props, context) {
    const channelName = computed(() => props.channel?.productName);
    const channelSelectViewVisible = ref(false);

    // 打开渠道选择弹窗
    const openChannelSelectView = () => {
      channelSelectViewVisible.value = true;
    };

    // 关闭渠道选择弹窗
    const closeChannelSelectView = () => {
      channelSelectViewVisible.value = false;
    };

    // 更新渠道选择弹窗
    const updateChannelSelectViewVisible = (visible: boolean) => {
      channelSelectViewVisible.value = visible;
    };

    // 更新选中渠道
    const updateSelectChannel = (channel: ApplyChannelData) => {
      context.emit('change', channel, channel.disabled === ChannelDisableEnum.NOT_AVAILABLE);
    };

    return {
      channelName,
      openChannelSelectView,
      closeChannelSelectView,
      channelSelectViewVisible,
      updateChannelSelectViewVisible,
      displayLoadingText,
      updateSelectChannel,
    };
  },
});
